var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 75,
    height: 75,
    transform: "translate(1212 5787)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_22",
    "data-name": "Mask Group 22",
    transform: "translate(-1212 -5787)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera_1_",
    "data-name": "camera (1)",
    transform: "translate(1212 5787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M68.391,28.434,56.4,32.068V24.78H53.012a11.665,11.665,0,0,0-17.392-15.5,14.585,14.585,0,1,0-24.013,15.5h-5V59.786H24.172L13.569,75h5.357L29.308,60.1V75H33.7V60.1L44.086,75h5.357l-10.6-15.214H56.4V52.5l11.989,3.634ZM64,50.208l-7.594-2.3V36.66L64,34.358ZM11,55.391V29.175h41V55.391Zm.834-40.8A10.193,10.193,0,1,1,22.031,24.78,10.2,10.2,0,0,1,11.838,14.587ZM43.9,10.225A7.277,7.277,0,1,1,36.618,17.5,7.286,7.286,0,0,1,43.9,10.225Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M22.386,40.086H40.625V44.48H22.386Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup22);
export default __webpack_public_path__ + "static/media/Mask Group 22.c9b8e6f435c32972558f5ca7ba0a806a.svg";
export { ForwardRef as ReactComponent };